import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a124b906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-2-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-2-explainer" }, " Statements and Invoices can now be printed and emailed: ", -1))
const _hoisted_3 = { class: "step-2-toggle" }
const _hoisted_4 = { class: "row-fields-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement for your own files.", -1))
const _hoisted_6 = { class: "controls-row" }
const _hoisted_7 = { class: "row-fields-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement to post.", -1))
const _hoisted_9 = { class: "controls-row" }
const _hoisted_10 = { class: "row-fields-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Produces Emails and attaches Statements as a PDF.", -1))
const _hoisted_12 = { class: "controls-row" }
const _hoisted_13 = { class: "row-fields-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "View the Payment Export file.", -1))
const _hoisted_15 = { class: "controls-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import { PaymentRunContactAPIFilters } from "@/types/accounts/PaymentRunContactAPIFilters";
import { PropType, ref, computed } from "vue";
import { ProcessedPaymentRun } from "@/types/accounts/ProcessedPaymentRun";
import { DxButton } from "devextreme-vue";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { Templates } from "@/enums/constants/Templates";
import SummaryCustomPanel from "@/components/financials/summary-custom-panel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-run-step-two',
  props: {
  /**
   * The filters for processing the selected payment runs.
   * @type {boolean}
   * @required
   */
  filters: {
    type: Object as PropType<PaymentRunContactAPIFilters>,
    required: true,
  },
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  processSuccessful: {
    type: Boolean,
    required: true,
  },
  /**
   * The boolean value determines when the email button should be enabled - only after a payment run is processed and one or more contacts can be selected.
   * @type {boolean}
   * @required
   */
  enableEmailButton: {
    type: Boolean,
    required: true,
  },
  /**
   * The boolean value determines when the email button should be enabled - only after a payment run is processed and one or more contacts can be sent letters.
   * @type {boolean}
   * @required
   */
  enableButtonPrintForPosting: {
    type: Boolean,
    required: true,
  },
  /**
   * The number of contacts that can be emailed after the payments have been processed.
   * @type {boolean}
   * @required
   */
  numberOfContactsToEmail: {
    type: Number,
    required: true,
  },
  /**
   * The number of contacts that can be sent letters after the payments have been processed.
   * @type {boolean}
   * @required
   */
  numberOfContactsToPost: {
    type: Number,
    required: true,
  },
  /**
   * The processed payment run data, used to download the payment run pdfs.
   * @type {boolean}
   * @required
   */
  processedPaymentRun: {
    type: Object as PropType<ProcessedPaymentRun>,
    required: false,
  },
  /**
   * The boolean value used with `v-model. Used in the endpoint request to process the selected paymnets. It's also used to download the paymnet run pdfs.
   * @type {boolean}
   * @required
   */
  preferredDeliveryMethodsToBeUsed: {
    type: Boolean,
    required: true,
  },
  /**
   * This list of property ids is used in the email modal so the correct properties can be used.
   * @type {boolean}
   * @required
   */
  propertyIds: {
    type: Array as PropType<number[]>,
    required: true,
  },
  /**
   * This list of contact ids is used in the email modal so the correct contacts can be emailed.
   * @type {boolean}
   * @required
   */
  contactIds: {
    type: Array as PropType<number[]>,
    required: true,
  },
  /**
   * These files are used in the email modal to be attached to the email that is sent.
   * @type {boolean}
   * @required
   */
  filesToEmail: {
    type: Array as PropType<File[]>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `preferredDeliveryMethodsToBeUsed` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:preferredDeliveryMethodsToBeUsed",
],
  setup(__props, { emit }) {

const props = __props;





const preferredDeliveryMethodsToBeUsed = computed({
  get: () => props.preferredDeliveryMethodsToBeUsed,
  set: (value: boolean) => {
    emit("update:preferredDeliveryMethodsToBeUsed", value);
  },
});

const financialHelper = useFinancialHelper();
const openEmailModal = ref(false);
const processStatementsCount = computed(() => {
  return props.processedPaymentRun
    ? props.processedPaymentRun.payments.length.toString()
    : "0";
});

// Step 2 button functions
const viewPaymnetExportFile = async () => {
  let file = await financialHelper.fetchPaymentExportFile(
    props.processedPaymentRun!,
  );

  if (!file) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(file);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payment-run.csv`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const downloadPaymentRunRequest = computed(() => {
  return {
    bankAccountId: props.filters.bankAccountId,
    allForFiling: true,
    contactType: props.filters.contactType,
    usePreferredDeliveryMethod: preferredDeliveryMethodsToBeUsed.value,
    payments: props.processedPaymentRun?.payments.map((payment) => {
      return {
        contactId: payment.contactId,
        propertyId: payment.propertyId,
        statementId: payment.statementId,
      };
    }),
  };
});

const printStatements = async () => {
  let file: Blob | undefined = await financialHelper.downloadPaymentRuns(
    downloadPaymentRunRequest.value,
  );

  if (!file) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(file);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payment-run-statment-${Date.now()}.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const printStatementsForPost = async () => {
  const file: Blob | undefined = await financialHelper.downloadPaymentRuns(
    downloadPaymentRunRequest.value,
  );

  if (!file) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(file);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payment-run-statment-${Date.now()}.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const produceEmails = () => {
  openEmailModal.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SwitchToggle, {
          modelValue: preferredDeliveryMethodsToBeUsed.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((preferredDeliveryMethodsToBeUsed).value = $event)),
          label: "Use Contacts' Preferred Delivery Method i.e. Email/Post/Both",
          "read-only": !__props.processedPaymentRun
        }, null, 8, ["modelValue", "read-only"])
      ]),
      _createVNode(SummaryCustomPanel, {
        title: "Preview / Print for Filing",
        icon: "fa-regular fa-print"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AcquaintInfoBox, { text: processStatementsCount.value }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                onClick: printStatements,
                text: "Preview/Print",
                "styling-mode": "contained",
                disabled: !__props.processedPaymentRun
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Preview / Print for Posting",
        icon: "fa-regular fa-envelope"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(AcquaintInfoBox, {
                text: String(__props.numberOfContactsToPost)
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                onClick: printStatementsForPost,
                text: "Preview/Print",
                "styling-mode": "contained",
                disabled: !__props.enableButtonPrintForPosting
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Email",
        icon: "fa-regular fa-at"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(AcquaintInfoBox, {
                text: String(__props.numberOfContactsToEmail)
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                onClick: produceEmails,
                text: "Email",
                "styling-mode": "contained",
                disabled: !__props.enableEmailButton
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Payment Export file",
        icon: "fa-regular fa-file"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_unref(DxButton), {
                onClick: viewPaymnetExportFile,
                text: "View",
                "styling-mode": "contained",
                disabled: !__props.processSuccessful
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(EmailFormModal, {
      modelValue: openEmailModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((openEmailModal).value = $event)),
      emailTemplateId: _unref(Templates).PropertySummaryAccountStatementEmail,
      propertyRelatedToId: __props.propertyIds,
      contactList: __props.contactIds,
      paymentRunFiles: __props.filesToEmail
    }, null, 8, ["modelValue", "emailTemplateId", "propertyRelatedToId", "contactList", "paymentRunFiles"])
  ], 64))
}
}

})